if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        if (this.form) {
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.form) return;
        if (this.isSubmitting) return; // Prevent duplicate requests
        this.isSubmitting = true;

        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton) {
          submitButton.classList.remove("is-success", "is-error");
          submitButton.classList.add("is-submitting");
          submitButton.setAttribute("disabled", "true");
        }

        // Get Cart API Config
        let config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const cartNotification = document.querySelector("cart-notification");
        const cartItems = document.querySelector("cart-items");

        let formData = new FormData(this.form);
        if (cartNotification && typeof cartNotification.getSectionsToRender === "function") {
          formData.append(
            "sections",
            cartNotification
              .getSectionsToRender()
              .map((section) => section.id)
          );
          if (typeof cartNotification.setActiveElement === "function") {
            cartNotification.setActiveElement(document.activeElement);
          }
        }

        if (cartItems && typeof cartItems.getSectionsToRender === "function") {
          formData.append(
            "sections",
            cartItems
              .getSectionsToRender()
              .map((section) => section.section)
          );
        }

        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((parsedState) => {
            if (parsedState.status) {
              this.handleErrorMessage(parsedState.description || "Could not add to cart.");
              if (submitButton) {
                submitButton.classList.remove("is-submitting");
                submitButton.classList.add("is-error");
                setTimeout(() => {
                  submitButton.classList.remove("is-error");
                  submitButton.removeAttribute("disabled");
                  this.isSubmitting = false;
                }, 1500);
              } else {
                this.isSubmitting = false;
              }
              return;
            }

            // Silently update drawer markup WITHOUT opening it (openDrawer = false)
            if (cartNotification && typeof cartNotification.renderContents === "function") {
              cartNotification.renderContents(parsedState, false);
            }

            if (cartItems && typeof cartItems.renderContents === "function") {
              cartItems.renderContents(parsedState);
            }

            // Sync all badges globally
            const badges = document.querySelectorAll(
              '#cart-notification-count, #cart-notification-count-mobile, .mobile__nav-badge, .cart-count-bubble'
            );
            fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
              .then((r) => r.json())
              .then((cart) => {
                if (cart && cart.item_count !== undefined) {
                  badges.forEach((b) => {
                    b.textContent = String(cart.item_count);
                    if (cart.item_count > 0) {
                      b.style.display = '';
                      b.classList.remove('d-none');
                    }
                  });
                  document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
                }
              })
              .catch(() => {});

            document.querySelector(".product-form__error-message-wrapper")?.classList.add("no-js-inline");

            if (submitButton) {
              submitButton.classList.remove("is-submitting");
              submitButton.classList.add("is-success");

              // Smoothly reset back to READY state after 1200ms per state machine design
              setTimeout(() => {
                submitButton.classList.remove("is-success");
                submitButton.removeAttribute("disabled");
                this.isSubmitting = false;
              }, 1200);
            } else {
              this.isSubmitting = false;
            }
          })
          .catch((e) => {
            console.error("Product add-to-cart error:", e);
            this.handleErrorMessage("Could not add to cart. Please try again.");
            if (submitButton) {
              submitButton.classList.remove("is-submitting");
              submitButton.classList.add("is-error");
              setTimeout(() => {
                submitButton.classList.remove("is-error");
                submitButton.removeAttribute("disabled");
                this.isSubmitting = false;
              }, 1500);
            } else {
              this.isSubmitting = false;
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );
        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
          this.errorMessageWrapper.classList.remove("no-js-inline");
        }
      }
    }
  );
}
